const getOdigeoABValue = (name) => {
    return Odigeo.AB[name];
};

const getOdigeoUtilsFunction = (name) => {
    return Odigeo.Utils[name];
};

const getFlow = () => {
    return Odigeo.SessionScope.flow;
};

const setOdigeoSession = (prop, value) => {
    Odigeo.Session.set(prop, value);
};

const removeOdigeoSessionProperty = (prop) => {
    Odigeo.Session.remove(prop);
};

const getOdigeoSessionValue = (prop) => {
    return Odigeo.Session.get(prop);
};

const getUrlService = (service, endpoint) => {
    return Odigeo.Settings.property(service)(endpoint);
};

const getOdigeoLocation = () => {
    return Odigeo.Device.location;
};

module.exports = {
    getOdigeoABValue,
    getOdigeoUtilsFunction,
    getFlow,
    setOdigeoSession,
    removeOdigeoSessionProperty,
    getOdigeoSessionValue,
    getUrlService,
    getOdigeoLocation,
};
